import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'absoluteDate',
  standalone: true
})

export class AbsoluteDatePipe implements PipeTransform {
  public transform(value: moment.MomentInput): string {
    if (value) {
      const dateTime = moment.parseZone(value);
      return dateTime.format('MMM-DD-YY');
    } else {
      return '';
    }
  }
}
